import { Dialog } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { ArrowRight2, CloseSquare } from 'iconsax-react'
import { initialValues } from '../context/RegisterContext'

interface ITopupProps {
  product?: string
  open: boolean
  handleClose: any
}
function Topup(props: ITopupProps) {
  return (
    <div className="prose w-full">
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        sx={{
          '& .MuiPaper-root ': {
            width: '100%',
          },
        }}
      >
        <div className="bottom-0 h-max p-4 rounded-md bg-white min-w-full w-full   max-w-md">
          <div className="flex justify-end w-full mb-4">
            <button
              onClick={props.handleClose}
              className="btn btn-sm  text-white border-none bg-transparent"
            >
              <CloseSquare size="22" color="#602977" />
            </button>
          </div>
          <Formik
            initialValues={{
              amount: 0,
              product: props.product || 'Legacy Money Market Fund',
              isDirectDebit: true,
            }}
            onSubmit={() => {}}
          >
            {({ values }) => (
              <Form>
                <div className="mb-6">
                  <h3 className="mb-1 text-sm font-semibold">Product Type:</h3>
                  <Field
                    name="product"
                    className="input input-bordered w-full bg-transparent text-black border-2"
                    disabled
                  />
                </div>
                <div className="mb-6">
                  <h3 className="mb-1 text-sm font-semibold">Amount:</h3>
                  <Field
                    name="amount"
                    className="input input-bordered w-full bg-transparent border-2"
                  />
                </div>
                <div className="mb-6 flex gap-2 items-center ">
                  <h3 className="mb-1 text-sm font-semibold">
                    Do you want to set up direct debit?
                  </h3>
                  <Field
                    type="checkbox"
                    name="isDirectDebit"
                    className="toggle  bg-[#602977] hover:bg-[#602977] "
                    // value={true}
                  />
                </div>

                <div className="">
                  <h3 className="mb-6 text-sm font-semibold">
                    Choose Payment Option
                  </h3>
                  <div className="mb-4 border btn px-2  w-full h-20 border-[#5F138D] bg-transparent justify-between">
                    <p className="text-[#5F138D]">Bank Transfer</p>
                    <ArrowRight2 size="12" color="#5F138D" />
                  </div>
                  <button className="mb-4 border btn  px-2  w-full h-20 border-[#5F138D] hover:bg-[#5F138D] text-[#5F138D] hover:text-white bg-transparent justify-between">
                    Pay with Card
                    <ArrowRight2 size="12" color="#5F138D" />
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Dialog>
    </div>
  )
}

export default Topup
